"use client";

import { QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { SessionProvider } from "next-auth/react";
import { ReactNode } from "react";
import { Toaster } from "react-hot-toast";
import { queryClient } from "@/lib/query-client";
import { AgentProvider } from "@/components/agent/AgentProvider";
import { TooltipProvider } from "@/components/ui/tooltip";
import { GpuStatusIndicator } from "@/components/GpuStatusIndicator";

export function Providers({ children }: { children: ReactNode }) {
  return (
    <SessionProvider
      refetchInterval={5 * 60} // Refresh session every 5 minutes to keep tokens fresh
      refetchOnWindowFocus={true} // Refresh session when user returns to tab
    >
      <QueryClientProvider client={queryClient}>
      <TooltipProvider>
        {children}
        {/* Toast notifications */}
        <Toaster
          position="top-center"
          toastOptions={{
            duration: 3000,
            style: {
              background: '#333',
              color: '#fff',
            },
            success: {
              iconTheme: {
                primary: '#10B981',
                secondary: '#fff',
              },
            },
            error: {
              iconTheme: {
                primary: '#EF4444',
                secondary: '#fff',
              },
            },
          }}
        />
        {/* Agent FAB and Sidebar - visible on all authenticated pages */}
        <AgentProvider />
        {/* GPU Status Indicator - shows when GPU is running (admin only) */}
        <GpuStatusIndicator />
        {/* React Query Devtools - only shows in development */}
        <ReactQueryDevtools initialIsOpen={false} />
      </TooltipProvider>
      </QueryClientProvider>
    </SessionProvider>
  );
}